<script setup lang="ts">
import { useCurrentUser } from 'vuefire';
import { useRoute, useRouter } from 'vue-router';
import { watch } from 'vue';
import NavigationBar from '@/components/NavigationBar.vue'
import { useDark } from '@vueuse/core';
import {datadogRum} from "@datadog/browser-rum";

const user = useCurrentUser();
const router = useRouter();
const route = useRoute();
const prefersDarkMode = useDark();

watch(user, async (currentUser, previousUser) => {
  if (currentUser) {
    // IDE is saying this is deprecated but it doesn't seem to be
    datadogRum.setUser({
      id: currentUser.uid,
    });
  } else {
    datadogRum.clearUser();
  }

  if (route.meta.requiresAuth && !currentUser && previousUser) {
    return router.push({ name: 'signout' });
  }
});

</script>

<template>
  <NavigationBar />
  <div :class="['container', prefersDarkMode ? 'dark' : 'light']">
    <div class="row">
      <div class="col">
        <img
          height="100px"
          :src="prefersDarkMode ? '/NLA-logo-large-white-text.png' : '/NLA-logo-large.png'"
          alt="NLA Media Access logo"
        >
      </div>
    </div>
    <div class="row">
      <div class="col">
        <router-view />
      </div>
    </div>
  </div>
</template>

<style scoped></style>
